<template>
  <div class="poll-articles">
    <!-- label -->
    <SectionLabel text="牽動選情"/>

    <!-- headline articles -->
    <div class="poll-articles__headline">
      <div class="poll-articles__item" v-for="article in articlesTop3" :key="article.id">
        <div class="poll-articles__content clearfix">
          <a class="poll-articles__photo"
            target="_blank"
            :title="article.title"
            :href="article.url"
            :style="`background-image: url(${article.image})`"
            @click="onLinkClick(article.id)">
          </a>
          <div class="poll-articles__overview">
            <div class="poll-articles__head">
              <h3 class="poll-articles__title"
                :title="article.title">
                <a target="_blank"
                  :title="`${article.title} - 詳細內文`"
                  :href="article.url"
                  @click="onLinkClick(article.id)">{{ article.title }}</a>
              </h3>
              <h4 class="poll-articles__subtitle">{{ article.subtitle }}</h4>
            </div>
            <div class="poll-articles__summary">{{ article.description | ellipsis(150) }}</div>
            <div class="poll-articles__detail"><!--
            --><a class="poll-articles__link"
                  target="_blank"
                  :title="`${article.title} - 詳細內文`"
                  :href="article.url"
                  @click="onLinkClick(article.id)"><!--
              --><SvgSymbol class="poll-articles__link-icon" use="#arrow-down"/><!--
              --><span class="poll-articles__link-text">詳細內文</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import articles from '@/data/articles'

export default {
  name: 'PollArticles',
  components: {
    SectionLabel
  },
  filters: {
    ellipsis (text, maxLen = 95) {
      let len = text.length
      if (len > maxLen) {
        return `${text.slice(0, maxLen)}...`
      }
      return text
    }
  },
  inject: [ 'baseUrl' ],
  data () {
    return {
      articles
    }
  },
  computed: {
    articlesTop3 () {
      let { hostname } = window.location
      let isPreview = hostname !== 'udn.com'
      return this.articles
        .slice(0, 3)
        .map(article => {
          if (isPreview) {
            article.url = article.url.replace(/\/event\/election2020_(.+)/, '/event_preview/election2020_$1')
          }
          return article
        })
    }
  },
  methods: {
    onLinkClick (id) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Link',
        'eventAction': 'Click',
        'eventLabel': `Link-to-article-${id}`
      })
      console.log(`@${this.$options.name} [linktoOtherPage]`)
    }
  }
}
</script>

<style lang="scss">
.poll-articles {
  $comp: &;
  // @include use-layer(&);
  position: relative;
  min-height: 100vh;
  // padding-bottom: 20px;
  background: #faf3ef;
  overflow: hidden;
  @include rwd($RWD_TABLET_SMALL) {
    padding-top: 10px;
  }
  @include rwd($RWD_TABLET) {
    padding-top: 30px;
  }
  @include rwd($RWD_DESKTOP) {
    padding-bottom: 50px;
  }
  @include rwd($RWD_DESKTOP_WIDE) {
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: -290px;
    left: 0;
    width: 100%;
    height: 400px;
    background: #f5c6b8;
    transform: skewY(-18deg);
    @include rwd($RWD_TABLET_SMALL) {
      transform: skewY(-10deg);
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      top: -600px;
      height: 800px;
    }
  }

  // override section-label
  .section-label {
    margin-top: 100px;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 80px;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 60px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 150px;
    }

    &__title {
      &:after {
        background: #7e93ce;
      }
    }
  }

  &__intro {
    position: relative;
    margin: 20px 12px;
    font-size: 0.875em;
    font-weight: 600;
    font-family: "Noto Serif TC";
    line-height: 1.7142em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 30px 36px;
      font-size: 1em;
      line-height: 1.625em;
    }
    @include rwd($RWD_TABLET) {
      width: 520px;
      margin: 40px auto 0;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP) {
      width: 770px;
      margin: 30px auto 0;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 910px;
      margin: 55px auto 0;
    }
  }

  &__headline {
    @include rwd($RWD_TABLET_SMALL) {
      width: 520px;
      margin: 0 auto;
    }
    @include rwd($RWD_DESKTOP) {
      width: 880px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 95%;
      max-width: 1150px;
    }
    @include rwd($RWD_DESKTOP_WIDE_1660) {
      width: 1440px;
      max-width: none;
    }

    #{$comp}__item {
      margin: 46px 5px 0 5px;
      background: #faf3ef;
      border: 5px solid #7e93ce;
      @include rwd($RWD_TABLET_SMALL) {
        margin: 70px 13px 0 13px;
      }
      @include rwd($RWD_TABLET) {
        margin-top: 70px;
      }
      @include rwd($RWD_DESKTOP) {
        margin-top: 110px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
      }

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 160px;
        background: #7e93ce;

        @include rwd($RWD_TABLET_SMALL) {
          height: 220px;
        }
        @include rwd($RWD_DESKTOP) {
          width: 131px;
          height: 100%;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
        }
      }

      &:first-child {
        margin-top: 51px;
        @include rwd($RWD_TABLET_SMALL) {
          margin-top: 70px;
        }
        @include rwd($RWD_TABLET) {
          margin-top: 65px;
        }
        @include rwd($RWD_DESKTOP) {
          margin-top: 40px;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          margin-top: 90px;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          margin-top: 120px;
        }
      }

      #{$comp}__photo {
        @include rwd($RWD_DESKTOP) {
          width: 54.55%;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          top: -30px;
          width: 53.15%;
        }
        @include rwd($RWD_DESKTOP_WIDE_1660) {
          top: -66px;
        }
      }

      #{$comp}__overview {
        @include rwd($RWD_DESKTOP) {
          width: 45.45%;
          height: 100%;
          padding: 5px 0;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          padding: 53px 0 40px 0;
          width: 46.85%;
        }
        @include rwd($RWD_DESKTOP_WIDE_1660) {
          padding: 95px 0 40px 0;
        }
      }

      #{$comp}__detail {
        @include rwd($RWD_DESKTOP) {
          height: 0;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          height: auto;
        }
      }

      #{$comp}__link {
        @include rwd($RWD_DESKTOP) {
          position: absolute;
          bottom: 35px;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          // bottom: 66px;
        }
      }

      // odd
      &:nth-child(2n + 1) {
        #{$comp}__photo {
          @include rwd($RWD_DESKTOP) {
            float: left;
          }
        }
        #{$comp}__overview {
          @include rwd($RWD_DESKTOP) {
            float: right;
            padding-left: 30px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            padding-left: 40px;
          }
          @include rwd($RWD_DESKTOP_WIDE_1660) {
            padding-left: 85px;
          }
        }
        #{$comp}__detail {
        }
        #{$comp}__link {
          @include rwd($RWD_DESKTOP) {
            right: 40px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            right: 65px;
          }
          @include rwd($RWD_DESKTOP_WIDE_1660) {
            right: 85px;
          }
        }
      }

      // even
      &:nth-child(2n) {
        &:before {
          @include rwd($RWD_DESKTOP) {
            left: auto;
            right: -5px;
          }
        }
        #{$comp}__photo {
          @include rwd($RWD_DESKTOP) {
            float: right;
          }
        }
        #{$comp}__overview {
          @include rwd($RWD_DESKTOP) {
            float: left;
            padding-right: 25px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            padding-right: 40px;
          }
          @include rwd($RWD_DESKTOP_WIDE_1660) {
            padding-right: 85px;
          }
        }
        #{$comp}__detail {
        }
        #{$comp}__link {
          @include rwd($RWD_DESKTOP) {
            right: 54.55%;
            margin-right: 25px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            margin-right: 20px;
          }
          @include rwd($RWD_DESKTOP_WIDE_1660) {
            margin-right: 60px;
          }
        }
      }
    }
  }

  &__item {
    position: relative;
  }

  &__content {
    position: relative;
    top: -17px;
    padding: 0 7px;

    @include rwd($RWD_TABLET_SMALL) {
      top: -22px;
      padding: 0 15px;
    }
    @include rwd($RWD_DESKTOP) {
      top: auto;
      padding: 35px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      padding: 0 65px;
    }
    @include rwd($RWD_DESKTOP_WIDE_1660) {
      padding: 0 85px;
    }
  }

  &__photo {
    display: block;
    position: relative;
    background: #f1f1f1 no-repeat top center / cover;
    cursor: pointer;
    @include use-fixed-ratio(4, 3);
  }

  &__overview {
    padding: 28px 4px 31px 4px;
    color: #1a1a1a;

    @include rwd($RWD_TABLET_SMALL) {
      padding: 31px 8px;
    }
  }

  &__title {
    color: #1a1a1a;
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.2em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1.5em;
      line-height: 1.25em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.875em;
      line-height: 1.2em;
    }
    @include rwd($RWD_DESKTOP) {
      font-size: 1.5em;
      line-height: 1.5em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      font-size: 1.875em;
      line-height: 1.2em;
    }
    @include rwd($RWD_DESKTOP_WIDE_1660) {
    }
  }

  &__subtitle {
    margin-top: 10px;
    color: #7e93ce;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.25em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 5px;
      font-size: 1.125em;
      line-height: 2em;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 10px;
      font-size: 1.25em;
      line-height: 1.5em;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 5px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 10px;
      font-size: 1.25em;
      line-height: 1.4em;
    }
  }

  &__summary {
    margin-top: 10px;
    font-size: 0.875em;
    font-weight: bold;
    text-align: justify;
    text-justify: inter-word;
    line-height: 1.714em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 5px;
      font-size: 1em;
      line-height: 1.714em;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 13px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 10px;
      font-size: 1em;
      line-height: 1.5em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 13px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
  }

  &__detail {
    width: 100%;
    margin-top: 32px;
    text-align: center;
    @include use-vertical-align();
  }

  &__link {
    display: inline-block;
    min-width: 142px;
    height: 40px;
    color: white;
    text-align: center;
    line-height: 1em;
    letter-spacing: 0.1em;
    vertical-align: middle;
    background: #7e93ce;
    border-radius: 2px;
    @include use-vertical-align();
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 160px;
      height: 45px;
    }

    &:active {
      transform: translateY(1px);
    }

    &-icon {
      display: inline-block;
      position: relative;
      width: 14px;
      height: 8px;
      vertical-align: middle;
      transform: rotate(-90deg);
    }

    &-text {
      margin-left: 5px;
      vertical-align: middle;
      @include rwd($RWD_DESKTOP_WIDE) {
        font-size: 1.125em;
      }
    }
  }
}

.desktop {
  .poll-articles {
    $comp: ".poll-articles";

    #{$comp}__link {
      &:hover {
        background: #f5c6b8;
        transition: background-color 0.3s;
      }
    }
  }
}
</style>
